export default __webpack_public_path__ + "static/media/icon-report-synthesis.7e55c81a.svg";